import React from 'react';

import styles from './PickupTimelineNotification.module.scss';

export interface PickupTimelineNotificationProps {
  iconUrl: string;
  title: string;
  description: string;
  variant: 'danger' | 'warning' | 'info';
  action?: {
    label: string;
    iconUrl?: string;
    onClick: () => void;
  };
}

export const PickupTimelineNotification: React.FC<PickupTimelineNotificationProps> = ({
  iconUrl, title, description, variant = 'info', action,
}) => (
  <div className={`${styles['snackbars-grey']} ${styles[`bg-${variant}`]}`} onClick={(event) => event.stopPropagation()}>
    <div className={styles.title}>
      <div className={styles['icon-l']}>
        <img src={iconUrl} alt="alert icon" color="#E6BB30" />
      </div>
      <div className={styles.caption}>{title}</div>
    </div>

    <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />

    {action && (
    <button
      className={styles['buttons-elements']}
      onClick={(event) => action.onClick?.()}
    >
      <div className={styles.body}>
        {action.iconUrl && (
        <div className={styles['icon-l']}>
          <img src={action.iconUrl} alt="airplane icon" />
        </div>
        )}
        <div className={styles['caption-2']}>{action.label}</div>
      </div>
    </button>
    )}
  </div>
);
